import {Theme} from '@mui/material/styles';

export default function Tabs(theme: Theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  };
}
